export default __webpack_public_path__ + "static/media/chopizz final (1).042db9e2.png";